module.exports = __webpack_public_path__ + "img/20191029163942454.29c55de3.jpg";